import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { ExpenseService } from 'app/shared/services/expense.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-income-statement',
  templateUrl: './income-statement.component.html',
  styleUrls: ['./income-statement.component.css']
})
export class IncomeStatementComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>

  fromDate : Date;
  toDate : Date;
  isDark: boolean = false;
 
  invoiceLst : any[]=[];
  filteredInvoiceList : any[]=[];
  expenseLst : any[]=[];
  filteredExpenseList : any[]=[];
  companyName : string = null;

  sales : number;
  serviceIncome : number;
  barIncome : number;
  totalSales : number;
  costOfSales : number;
  grossProfit : number;
  adminExp : number;
  fishAndMeat : number;
  grocery : number;
  boatCharge: number;
  transport: number;
  distributionExp : number;
  marketingExp : number;
  maintenanceExp: number;
  salaryExp: number;
  financeExp : number;
  overhead: number;
  otherExp : number;
  totalExp : number;
  netProfit : number;


  constructor(
              private invoiceService  : InvoiceService , 
              private expenseService : ExpenseService, 
              private router : Router, 
              private themeService: NbThemeService,
              private companyProfileService: CompanyProfileService,
             )
              {
                this.datepickerConfig = Object.assign({},
                {   
                  showWeekNumbers:false,
                  dateInputFormat : 'YYYY-MM-DD'
                });

              }

    ngOnInit() {
      this.initPNLVariables();
      this.getAllInvoices();
      this.getAllExpBreakup(); 
      this. getCompanyDetails(); 
      
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
         });
    }

    initPNLVariables(){
      this.sales = 0.00;
      this.serviceIncome = 0.00;
      this.barIncome = 0.00;
      this.totalSales = 0.00;
      this.costOfSales = 0.00;
      this.grossProfit = 0.00;
      this.adminExp = 0.00;
      this.fishAndMeat = 0.00;
      this.grocery = 0.00;
      this.boatCharge= 0.00;
      this.transport= 0.00;
      this.distributionExp = 0.00;
      this.marketingExp = 0.00;
      this.maintenanceExp = 0.00;
      this.salaryExp= 0.00;
      this.financeExp = 0.00;
      this.otherExp = 0.00;
      this.totalExp = 0.00;
      this.netProfit = 0.00;

    }

    // initPNLVariablesValues(){
    //   this.salesIncome = 123500.00;
    //   this.costOfSales = 65200.00;
    //   this.grossProfit = 58300.00;
    //   this.adminExp = 12300.00;
    //   this.distributionExp = 8000.00;
    //   this.marketingExp = 2500.00;
    //   this.salaryExp= 15000.00;
    //   this.financeExp = 800.00;
    //   this.otherExp = 3000.00;
    //   this.totalExp = 41600.00;
    //   this.netProfit = 16700.00;

    // }

    getCompanyDetails(){
      this.companyProfileService.getCompanyDetails()
      .subscribe(
        (data) =>{
                  this.companyName = data.CompanyName;
                 
                  },
        (err) => {
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        }
      );
    
    }

    getAllInvoices(){
      this.invoiceService.getAll()
       .subscribe(
          (data) => {
                    this.invoiceLst = data;  
                    this.filteredInvoiceList =  this.invoiceLst ;                           
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });          
       }
  
 
    getAllExpBreakup(){
    this.expenseService.getAllExpBreakup()
     .subscribe(
        (data) => {
                  this.expenseLst = data;  
                  this.filteredExpenseList =   this.expenseLst;                           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

     getTotal(){
      return this.filteredExpenseList.map(data=>data.Amount).reduce((acc,value)=>acc + value,0);
    }
    

      viewBtnClicked(){
        this.initPNLVariables();
        if(this.fromDate && this.toDate){
            var startDate =moment(this.fromDate).format("YYYY-MM-DD");
            var endDate =moment(this.toDate).format("YYYY-MM-DD");

            this.filteredInvoiceList = this.invoiceLst.filter(date => {
                var expDate = moment(date.InvoiceDate).format("YYYY-MM-DD");              
                return moment(expDate).isBetween(startDate, endDate,undefined,'[]');
                });
                
            this.filteredExpenseList = this.expenseLst.filter(data => {
                  var expDate = moment(data.ExpDate).format("YYYY-MM-DD");              
                  return moment(expDate).isBetween(startDate, endDate,undefined,'[]');               
                  });

           this.sales = this.filteredInvoiceList.filter(data => (data.SalesType.trim()!=='Service' && data.SalesType.trim()!=='Bar Item')).map(data=>data.GrandTotal).reduce((acc,value)=>acc + +value,0);
           this.serviceIncome = this.filteredInvoiceList.filter(data => data.SalesType.trim()==='Service').map(data=>data.GrandTotal).reduce((acc,value)=>acc + +value,0);
           this.barIncome = this.filteredInvoiceList.filter(data => data.SalesType.trim()==='Bar Item').map(data=>data.GrandTotal).reduce((acc,value)=>acc + +value,0);
           this.totalSales = this.sales + this.serviceIncome + this.barIncome;

           this.costOfSales= this.filteredInvoiceList.map(totalBal=>totalBal.TotalCost).reduce((acc,value)=>acc + +value,0);
           this.grossProfit = this.totalSales - this.costOfSales;

           this.adminExp = this.filteredExpenseList.filter(data => data.ExpCategory==='Administration').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.fishAndMeat = this.filteredExpenseList.filter(data => data.ExpCategory==='Fish and Meat').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.grocery = this.filteredExpenseList.filter(data => data.ExpCategory==='Grocery').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.boatCharge = this.filteredExpenseList.filter(data => data.ExpCategory==='Boat Charge').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.transport = this.filteredExpenseList.filter(data => data.ExpCategory==='Transport').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.distributionExp = this.filteredExpenseList.filter(data => data.ExpCategory==='Distribution').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.marketingExp = this.filteredExpenseList.filter(data => data.ExpCategory==='Marketing').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.maintenanceExp = this.filteredExpenseList.filter(data => data.ExpCategory==='Maintenance').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);   
           this.salaryExp = this.filteredExpenseList.filter(data => data.ExpCategory==='Salary').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.financeExp = this.filteredExpenseList.filter(data => data.ExpCategory==='Finance').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.overhead = this.filteredExpenseList.filter(data => data.ExpCategory==='Overhead').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
           this.otherExp = this.filteredExpenseList.filter(data => data.ExpCategory==='Other').map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);


           this.totalExp = this.adminExp + this.fishAndMeat + this.grocery + this.boatCharge + this.transport + this.distributionExp + this.marketingExp + this.maintenanceExp +
                            this.salaryExp + this.financeExp +  this.overhead + this.otherExp;

           this.netProfit = this.grossProfit - this.totalExp;

        }

    
        
      }


     clearBtnClicked(){
      this.fromDate = null;
      this.toDate = null;
      this.initPNLVariables();
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('pnlReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Profit and Loss Statement.xlsx');
       
     }

    

}
